/* eslint no-unused-vars: 0 */

import React from "react"

class SiteSearchBrandResults extends React.PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      brands: []
    };
    this.cleanseBrands = this.cleanseBrands.bind(this);
  }

  cleanseBrands(brands) {
    return brands.filter((brand) => { return ('highlighted_name' in brand) })
  }

  componentDidMount() {
    if (this.props.categoryCount >= 7) {
      this.setState({
        brands: this.cleanseBrands(this.props.brands).slice(0, 3)
      });
    } else {
      this.setState({
        brands: this.cleanseBrands(this.props.brands)
      });
    }
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.categoryCount >= 7) {
      this.setState({
        brands: this.cleanseBrands(nextProps.brands).slice(0, 3)
      });
    } else {
      this.setState({
        brands: this.cleanseBrands(nextProps.brands)
      });
    }
  }

  render() {
    return (
      <div>
        {this.state.brands.length > 0 ? <h3>Brands</h3> : ""}
        <ul>
          {this.state.brands.map((b, index) => {
            return (
              <li
                key={index}
                dangerouslySetInnerHTML={{ __html: b.highlighted_name }}
                onClick={() => {
                  this.props.viewLink(b.url);
                }}
              />
            );
          })}
        </ul>
      </div>
    );
  }
}

export default SiteSearchBrandResults;
